exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".luck2021[data-v-cd335b4c]{padding:0 0 60px}.luck2021__price[data-v-cd335b4c]{margin-bottom:24px}.luck2021__subsc[data-v-cd335b4c]{margin:5.35% auto 0}.luck2021__counselors[data-v-cd335b4c]{margin:0 auto;padding:21px 8.55% 80px;background-color:#ffd3e1;background-image:linear-gradient(45deg,#ffc0e7 25%,transparent 0,transparent 75%,#ffc0e7 0),linear-gradient(45deg,#ffc0e7 25%,transparent 0,transparent 75%,#ffc0e7 0);background-size:20px 20px;background-position:0 0,10px 10px;position:relative}.luck2021__svg[data-v-cd335b4c]{position:absolute;bottom:-1px;left:0;width:100%}.luck2021__path[data-v-cd335b4c]{fill:#fff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cd335b4c","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/YearLuck/y2021/yearluck2021Top.vue
// module id = qhR2
// module chunks = 0